<template>
  <div>
    <v-btn color="secondary" class="mr-4" @click="abrir">Distribuidoras</v-btn>
    <v-dialog v-model="aberto" max-width="1100">
      <v-card dark color="quinta">
        <v-card-title>Distribuidoras <v-spacer /><v-btn icon aria-label="Fechar distribuidoras" @click="aberto=false"><v-icon>close</v-icon></v-btn></v-card-title>
        <v-card-text>
          <v-alert v-if="catalogo.erro" type="error" outlined>{{ catalogo.erro }}
            <v-btn text @click="recarregar">Tentar novamente</v-btn>
          </v-alert>
          <v-toolbar flat color="quinta">
            <v-text-field v-model="busca" label="Buscar distribuidora" append-icon="search" hide-details />
            <v-btn color="primeira" class="ml-5" @click="nova">Nova distribuidora</v-btn>
          </v-toolbar>
          <v-data-table :items="catalogo.itens" :headers="colunas" :search="busca" :loading="catalogo.carregando" item-key="objectId">
            <template #item.ativa="{ item }"><v-chip small :color="item.ativa ? 'success' : 'grey'">{{ item.ativa ? 'Ativa' : 'Inativa' }}</v-chip></template>
            <template #item.credencialConfigurada="{ item }">{{ item.credencialConfigurada ? 'Configurada' : 'Pendente' }}</template>
            <template #item.acoes="{ item }"><v-btn small text @click="editar(item)">Editar</v-btn></template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="formAberto" max-width="680" persistent>
      <v-card dark color="quinta">
        <v-card-title>{{ form.objectId ? 'Editar distribuidora' : 'Nova distribuidora' }}</v-card-title>
        <v-card-text>
          <v-alert v-if="erro" type="error" outlined>{{ erro }}</v-alert>
          <v-form ref="form" @submit.prevent="salvar">
            <v-text-field v-model="form.nomeExibicao" label="Nome de exibição" :rules="[obrigatorio]" outlined />
            <v-text-field v-model.number="form.sold" type="number" label="SOLD" :disabled="!!form.objectId" :rules="[soldValido]" outlined />
            <v-text-field v-model="form.nomeIntegracao" label="Nome para integração" :rules="[obrigatorio]" outlined />
            <v-text-field v-model="form.grupo" label="Grupo" :rules="[obrigatorio]" outlined />
            <v-text-field v-model="form.credencial" type="password" autocomplete="new-password"
              :label="form.objectId ? 'Nova credencial (opcional)' : 'Credencial de integração'"
              :hint="form.objectId ? 'Deixe vazio para conservar a credencial atual.' : 'Informe a credencial fornecida para este SOLD.'"
              persistent-hint :rules="form.objectId ? [] : [obrigatorio]" outlined />
            <v-switch v-model="form.ativa" label="Distribuidora ativa" />
            <p v-if="!form.ativa">A inativação impede novos vínculos e envios. Clientes e históricos permanecem disponíveis.</p>
          </v-form>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text :disabled="salvando" @click="formAberto=false">Cancelar</v-btn>
          <v-btn color="primeira" :loading="salvando" @click="salvar">Salvar distribuidora</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { urlApi } from "@/global";
import { catalogo, carregarDistribuidoras, mensagemErro } from "@/services/distribuidoras";
export default {
  name: "ManutencaoDistribuidoras",
  data: () => ({ catalogo, aberto: false, formAberto: false, form: {}, busca: "", erro: "", salvando: false,
    colunas: [
      { text: "Nome", value: "nomeExibicao" }, { text: "SOLD", value: "sold" },
      { text: "Grupo", value: "grupo" }, { text: "Situação", value: "ativa" },
      { text: "Credencial", value: "credencialConfigurada" }, { text: "", value: "acoes", sortable: false }
    ] }),
  methods: {
    obrigatorio: v => !!String(v || "").trim() || "Campo obrigatório.",
    soldValido: v => (Number.isSafeInteger(v) && v > 0) || "Informe um SOLD inteiro positivo.",
    abrir() { this.aberto = true; this.recarregar(); },
    recarregar() { carregarDistribuidoras(true).catch(() => {}); },
    nova() { this.form = { nomeExibicao: "", sold: null, nomeIntegracao: "", grupo: "", credencial: "", ativa: true }; this.erro = ""; this.formAberto = true; this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation()); },
    editar(item) { this.form = { ...item, credencial: "" }; this.erro = ""; this.formAberto = true; this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation()); },
    async salvar() {
      if (!this.$refs.form.validate()) return;
      this.salvando = true; this.erro = "";
      try {
        const endpoint = this.form.objectId ? "/alterar-distribuidora" : "/criar-distribuidora";
        await axios.post(urlApi + endpoint, this.form);
        this.form.credencial = "";
        this.formAberto = false;
        await carregarDistribuidoras(true);
        this.$toasted.global.defaultSuccess({ msg: "Distribuidora salva." });
      } catch (e) { this.erro = mensagemErro(e); }
      finally { this.salvando = false; }
    }
  }
};
</script>

